module.exports = __webpack_public_path__ + "img/Wild.882f33fe.png";